



   export const homepage= 
    [
      {
        id: 1,
        "topimg":"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Best-sellers-tag.png?v=10809169506792369733",
       
         image:"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/C-GlowFaceWash-01Medium_765x.jpg?v=1659101821",
         "himage":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Exfoliate-02Medium_360x.jpg?v=1659101350",
         "title":"C-Glow Face Wash, 100ml",
       
         "category":"De-Tan & Brightening",
         price:204.00,
         "strikeprice":"₹249.00"
        
      },
      {
        id: 2,
        "topimg":"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Best-sellers-tag.png?v=10809169506792369733",
       
        image:"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Exfoliate-01_1_Medium_a7654ecf-8f6c-4b46-9d27-f3c5e8a30f28_765x.jpg?v=1659101350",
        "himage":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Eyelift-02Medium_360x.jpg?v=1659101492",
        "title":"Exfoliate Face And Body Scrub Grit, 75gm",
    
      price:220.00,
      "strikeprice":"₹275.00"
    
       
      },
      {
        id: 3,
       
        "topimg":"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Best-sellers-tag.png?v=10809169506792369733",
        image:"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Eyelift-01Medium_765x.jpg?v=1659101492",
        "himage":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/NicoLips-02Medium_360x.jpg?v=1661428887",
        "title":"EyeLift Under Eye Cream, 20gm",
     
      "category":"Repairs Dark Circles, Puffy Eyes & Wrinkles",
      price:275.00,
      "strikeprice":"₹325.00"
      
       
      },
      {
        id: 4,
        "topimg":"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Best-sellers-tag.png?v=10809169506792369733",
       
        image:"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/NicoLips-01Medium_765x.jpg?v=1659101603",
        "himage":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Exfoliate_BevzillaCombo-02Medium_360x.jpg?v=1659101713",
        "title":"NicoLips Lip Brightening Scrub, 20gm",
     
      "category":"Lip Brightening, Nourishing & Repairing",
      price:364.00,
      "strikeprice":"₹450.00"
     
       
      },
      {
        id: 5,
        "topimg":"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Best-sellers-tag.png?v=10809169506792369733",
      
        image:"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Exfoliate_BevzillaCombo-01Medium_765x.jpg?v=1659101713",
        "himage":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/C-GlowFaceWash-02Medium_360x.jpg?v=1659101821",
        "title":"Ultimate Coffee Boost Combo",
      
      "category":"Exfoliate Face & Body Scrub, Coffee Cubes",
      price:399.00,
      "strikeprice":"₹624.00"
      
       
      },
      {
        id: 6,
        "topimg":"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Best-sellers-tag.png?v=10809169506792369733",
      
        image:"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Anti-AcneFaceGel-01Medium_765x.jpg?v=1659101934",
        "himage":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Anti-AcneFaceGel-02Medium_360x.jpg?v=1659101934",
        "title":"Anti Acne, Pimple Scar Spots Removal Gel For Men & Women, 50gm",
     
      "category":"Pimple Scar Removal & Skin Clarifying",
      price:343.00,
      "strikeprice":"₹399.00"
      
       
      },
      {
        id: 7,
        "topimg":"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Best-sellers-tag.png?v=10809169506792369733",
      
        image:"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/ManBox-01_765x.jpg?v=1652421642",
        "himage":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/ManBox-02_1410db0a-914d-4318-a11b-59f3e68c7cc6_360x.jpg?v=1652421646",
        "title":"Luxury Perfume Gift Set For Man - 4x20ml",
     
      "category":"Eau De Parfum",
      price:749.00,
      "strikeprice":"₹849.00"
      
       
      },
      {
        id: 8,
        "topimg":"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Best-sellers-tag.png?v=10809169506792369733",
       
        image:"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Kumkumadi-Face-Oil-01_765x.jpg?v=1652341175",
        "himage":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/KumkumadiFaceOil-02_360x.jpg?v=1652341175",
        "title":"Ayurvedic Kumkumadi Face Oil, 30ml",
     
      "category":"Skin Brightening & Hydrating Oil For Youthful Skin",
      price:499.00,
      "strikeprice":"₹599.00"
     
       
      }
      
    ]

   export const productpage=    [
         {
           
         
           "topimg":"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Best-sellers-tag.png?v=10809169506792369733",
          
           "image":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/listingimages2_360x.jpg?v=1657522217",
           "himage":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/listingimages2_360x.jpg?v=1657522217",
           "title":"Aloe Vera Soothing Gel For Skin & Hair, 200gm",
       
         "category":"Soothes, Repairs And Hydrates",
         "price":225.00,
         "strikeprice":"₹249.00",
         "rating":"5.0"
         },
         {
           
          
           "topimg":"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Best-sellers-tag.png?v=10809169506792369733",
          
           "image":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/HydraplusFaceWash-03_765x.jpg?v=1654164895",
           "himage":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/HydraplusFaceWash-02_360x.jpg?v=1654164895",
           "title":"Hydra-Plus Face Wash ,100ml",
       
         "category":"Hydrating, Cleansing & Brightening",
         "price":225.00,
         "strikeprice":"₹279.00",
         "rating":"4.9"
         },
         {
           
           
           "topimg":"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Best-sellers-tag.png?v=10809169506792369733",
          
           "image":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Hydra-Plus-Face-Gel-03_765x.jpg?v=1654164918",
           "himage":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/HydraGel_360x.jpg?v=1655309460",
           "title":"Hydra-Plus Face Gel ,50gm",
       
         "category":"Hydrating & Moisturising",
         "price":349.00,
         "strikeprice":"₹399.00",
         "rating":"4.6"
         },
         {
           
          
           "topimg":"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Best-sellers-tag.png?v=10809169506792369733",
          
           "image":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Hydra-plusNightCream-03_765x.jpg?v=1654165749",
           "himage":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Hydra-plusNightCream-02_360x.jpg?v=1654165750",
           "title":"Hydra-Plus Night Cream ,50gm",
       
         "category":"Hydrating, Repairing And Nourishing",
         "price":381.00,
         "strikeprice":"₹499.00",
         "rating":"4.8"
         },
         {
           
           
           "topimg":"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Best-sellers-tag.png?v=10809169506792369733",
          
           "image":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Sunscreen-01_765x.jpg?v=1655472151",
           "himage":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Sunscreen-02_360x.jpg?v=1655472152",
           "title":"SPF 50 PA+++ Sunscreen",
       
         "category":"Protects, Hydrates, Brightens",
         "price":"284.00",
         "strikeprice":"₹379.00",
         "rating":"2.0"
         },
         {
           
          
           "topimg":"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Best-sellers-tag.png?v=10809169506792369733",
          
           "image":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/C-GlowFaceSerum-01_1_765x.jpg?v=1651698248",
           "himage":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/C-GlowFaceSerum-06_9d045130-dcb9-4c59-aa41-12ef9cafcdd1_360x.jpg?v=1652182969",
           "title":"C-Glow Face Serum ,30ml",
       
         "category":"Brightening & Anti Pigmentation",
         "price":349.00,
         "strikeprice":"₹375.00",
         "rating":"5.0"
         },
         {
           
          
           "topimg":"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Best-sellers-tag.png?v=10809169506792369733",
          
           "image":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/KumkumadiDayCream-01_757f9cf0-0c09-4baa-8a13-c6803a6e1f94_765x.jpg?v=1652341381",
           "himage":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/KumkumadiDayCream-02_360x.jpg?v=1652341381",
           "title":"Kumkumadi Day Cream ,50gm",
       
         "category":"Skin Brightening, Repair And Dryness",
         "price":449.00,
         "strikeprice":"₹549.00",
         "rating":"5.0"
         },
         {
           
     
           "topimg":"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Best-sellers-tag.png?v=10809169506792369733",
          
           "image":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/ReverseShampoo_Conditinor-01_1_765x.jpg?v=1651698374",
           "himage":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/ReverseShampoo_Conditinor-06_360x.jpg?v=1652183038",
           "title":"Reverse Hairwash Pack Of Conditioner & Shampoo, 200ml Each",
       
         "category":"Anti Frizz, Anti Hairfall & Nourishing",
         "price":499.00,
         "strikeprice":"₹599.00",
         "rating":"4.8"
         },
         {
           
          
           "topimg":"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Best-sellers-tag.png?v=10809169506792369733",
          
           "image":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Kumkumadi-Face-Oil-01_765x.jpg?v=1652341175",
           "himage":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/KumkumadiFaceOil-02_360x.jpg?v=1652341175",
           "title":"Ayurvedic Kumkumadi Face Oil, 30ml",
       
         "category":"Skin Brightening & Hydrating Oil For Youthful Skin",
         "price":499.00,
         "strikeprice":"₹599.00",
         "rating":"4.7"
         },
         {
           
         
           "topimg":"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Best-sellers-tag.png?v=10809169506792369733",
          
           "image":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/C-glowfacecream-01_fb37c9e3-d5f7-43f6-8b78-7efdd5d94b4b_765x.jpg?v=1652342130",
           "himage":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/C-glowfacecream-02_360x.jpg?v=1652342130",
           "title":"C-Glow Face Cream ,50ml",
       
         "category":"Brightening & Anti Pigmentation",
         "price":325.00,
         "strikeprice":"₹375.00",
         "rating":"5.0"
         },
         {
           
        
           "topimg":"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Best-sellers-tag.png?v=10809169506792369733",
          
           "image":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/C-GlowFaceToner-01_8d2e684c-751c-4160-8e59-e3eab4ca4614_765x.jpg?v=1652342196",
           "himage":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/C-GlowFaceToner-02_360x.jpg?v=1652342196",
           "title":"C-Glow Face Toner, 100ml",
       
         "category":"Hydrates & Nourishes",
         "price":225.00,
         "strikeprice":"₹249.00",
         "rating":"5.0"
         },
         {
           
       
           "topimg":"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Best-sellers-tag.png?v=10809169506792369733",
          
           "image":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/C-GlowFacePack-01_1_765x.jpg?v=1651698247",
           "himage":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/C-GlowFacePack-06_a7efe5f6-c85e-47af-b52d-faab3fadc577_360x.jpg?v=1652183004",
           "title":"C-Glow Face Pack, 100gm",
       
         "category":"Skin Brightening & Anti Blemish",
         "price":349.00,
         "strikeprice":"₹399.00",
         "rating":"5.0"
         },
         {
         
           "topimg":"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Best-sellers-tag.png?v=10809169506792369733",
          
           "image":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/CEOWoman-01_765x.jpg?v=1660127638",
           "himage":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/CEOWoman-02_2c444456-8831-47b6-9560-3bcea59216c9_360x.jpg?v=1660127638",
           "title":"CEO Woman Body Parfum No Gas Deodorant, 150ml",
       
         "category":"CEO Woman Body Parfum No Gas Deodorant",
         "price":249.00,
         "strikeprice":"₹299.00",
         "rating":"5.0"
         },
         {
           
           
           "topimg":"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Best-sellers-tag.png?v=10809169506792369733",
          
           "image":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Dominus-01_1_765x.jpg?v=1660127699",
           "himage":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Dominus-02_1_360x.jpg?v=1660127699",
           "title":"Dominus Man Body Parfum No Gas Deodorant, 150ml",
       
         "category":"Dominus Man Body Parfum No Gas Deodorant",
         "price":249.00,
         "strikeprice":"₹299.00",
         "rating":"5.0"
         },
         {
           
        
           "topimg":"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Best-sellers-tag.png?v=10809169506792369733",
          
           "image":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Impact-01_addf5a5d-8f6e-4ad2-a5ce-73b0ab71f18e_765x.jpg?v=1660127937",
           "himage":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Impact-02_360x.jpg?v=1660127937",
           "title":"IMPACT Man Body Parfum No Gas Deodorant, 150ml",
       
         "category":"IMPACT Man Body Parfum No Gas Deodorant",
         "price":249.00,
         "strikeprice":"₹299.00",
         "rating":"5.0"
         },
         {
           
          
           "topimg":"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Best-sellers-tag.png?v=10809169506792369733",
          
           "image":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Skai-01_765x.jpg?v=1651601264",
           "himage":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/Skai-02_360x.jpg?v=1651601264",
           "title":"SKAI Aquatic Man Body Parfum No Gas Deodorant, 150ml",
       
         "category":"SKAI Aquatic Man Body Parfum No Gas Deodorant",
         "price":249.00,
         "strikeprice":"₹299.00",
         "rating":"5.0"
         },
         {
           
           
           "topimg":"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Best-sellers-tag.png?v=10809169506792369733",
          
           "image":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/KumkumadiBox-01_765x.jpg?v=1659699561",
           "himage":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/GlamWoman-02_360x.jpg?v=1660127891",
           "title":"Kumkumadi Gift Box",
       
         "category":"Refreshes, Repairs, Rejuvenates",
         "price":929.00,
         "strikeprice":"₹1,547.00",
         "rating":"5.0"
         },
         {
           
          
           "topimg":"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Best-sellers-tag.png?v=10809169506792369733",
          
           "image":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/KumkumadiFaceWash-02_360x.jpg?v=1652341314",
           "himage":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/KumkumadiBox-02_360x.jpg?v=1659699561",
           "title":"Kumkumadi Face Wash - 100ml",
       
         "category":"Pore Cleansing, Radiating & Skin Rejuvenating",
         "price":320.00,
         "strikeprice":"₹399.00",
         "rating":"4.8"
         },
         {
           
           
           "topimg":"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Best-sellers-tag.png?v=10809169506792369733",
          
           "image":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/CEOMan-01_2_765x.jpg?v=1660127540",
           "himage":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/KumkumadiFaceWash-02_360x.jpg?v=1652341314",
           "title":"CEO Man Body Parfum No Gas Deodorant, 150ml",
       
         "category":"CEO Man Body Parfum No Gas Deodorant",
         "price":249.00,
         "strikeprice":"₹299.00",
         "rating":"5.0"
         },
         {
           
           
           "topimg":"https://cdn.shopify.com/s/files/1/0054/6665/2718/files/Best-sellers-tag.png?v=10809169506792369733",
          
           "image":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/ReverseShampoo_Conditinor-01_1_765x.jpg?v=1651698374",
           "himage":"https://cdn.shopify.com/s/files/1/0054/6665/2718/products/CEOMan-02_1_360x.jpg?v=1660127540",
           "title":"Reverse Hairwash Pack Of Conditioner & Shampoo, 200ml Each",
       
         "category":"Anti Frizz, Anti Hairfall & Nourishing",
         "price":499.00,
         "strikeprice":"₹599.00",
         "rating":"4.8"
         }
       ]
  
  